export const tabs = { private: 'PRIVATE', business: 'BUSINESS' };
